import { useState, useRef, useEffect } from 'react';
import { CTA_ICONS } from '../../content/iconOptions';
import styles from './IconPicker.module.css';

function IconPicker({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selectedIcon =
    CTA_ICONS.find((icon) => icon.value === value) || CTA_ICONS[0];

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const handleSelect = (iconValue) => {
    onChange(iconValue);
    setIsOpen(false);
  };

  return (
    <div className={styles.iconPickerContainer} ref={wrapperRef}>
      <button
        type="button"
        className={styles.pickerButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className={styles.selectedIconDisplay}>
          <i
            className={`${selectedIcon.value || 'fas fa-ban'} ${styles.iconSample}`}
          ></i>
          <span>{selectedIcon.label}</span>
        </div>
        <i
          className={`fas fa-chevron-down ${isOpen ? styles.chevronOpen : ''}`}
        ></i>
      </button>

      {isOpen && (
        <div className={styles.pickerDropdown}>
          {CTA_ICONS.map((icon) => (
            <button
              key={icon.value}
              type="button"
              className={styles.iconOption}
              onClick={() => handleSelect(icon.value)}
            >
              <i
                className={`${icon.value || 'fas fa-ban'} ${styles.iconSample}`}
              ></i>
              <span>{icon.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default IconPicker;
